import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { Observable } from 'rxjs';

import { CmpsDecimalWithSuffixPipe } from '../../common/number.pipe';
import { TranslationKeyMap } from '../coaching-insight.i18n';

import {
    CoachingComponentType,
    CoachingInsightComponent,
    CoachingInsightSubComponent,
} from './models/coaching.global.model';
import { ACTIVE_TAB_VIEW } from './models/oa.model';
import { CoachingInsightWidgetService } from './services/coaching-insight.widget.service';
import { TeamOAService } from './services/team-oa.service';

export {
    CoachingComponentStripComponent,
    CoachingComponent,
    CoachingComponentSubmenu,
};

// maintain a list of OANumbers
@Component({
    selector: 'cmps-coaching-component-strip',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div>
            <cmps-wait-status
                class="p-2"
                *ngIf="hasPendingData"
            ></cmps-wait-status>
            <div
                *ngIf="!hasPendingData && (coachingComponents | async) == null"
            >
                {{ i18n._711_NO_DATA_AVAILABLE | translate }}
            </div>
            <div
                class="row container-fluid"
                *ngIf="
                    !hasPendingData &&
                    (coachingComponents | async) as components
                "
            >
                <ng-content selector="[dynamic-content]"></ng-content>
                <div class="col-12 col-md-6 text-center">
                    <div
                        class="coaching-component-container"
                        *ngFor="let component of components"
                    >
                        <cmps-coaching-component
                            class="strip-coaching-component"
                            [hasPendingData]="hasPendingData"
                            [hasPendingPeople]="hasPendingPeople"
                            [activeTabView]="activeTabView | async"
                            [activeComponentId]="
                                activeComponent?.componentTypeId
                            "
                            [component]="component"
                            (toggledComponent)="
                                activateComponent($event);
                                toggledComponent.emit($event)
                            "
                            (hover)="hover = $event"
                        ></cmps-coaching-component>
                    </div>

                    <div
                        class="component-value-sub-sec"
                        *ngIf="
                            activeComponent &&
                            activeComponent?.coachingInsightSubComponents
                                ?.length &&
                            activeComponent.iconstate == true
                        "
                    >
                        <div class="component-value-item-sec">
                            <ng-container
                                *ngFor="
                                    let sub of activeComponent.coachingInsightSubComponents;
                                    let i = index
                                "
                            >
                                <cmps-coaching-submenu
                                    [sub]="sub"
                                    [activeTabView]="activeTabView | async"
                                    [subStyle]="getIconStyle()"
                                >
                                </cmps-coaching-submenu>
                                <span
                                    *ngIf="
                                        activeComponent
                                            .coachingInsightSubComponents
                                            .length > 1 &&
                                        i !=
                                            activeComponent
                                                .coachingInsightSubComponents
                                                .length -
                                                1
                                    "
                                    class="divider-line"
                                >
                                    |
                                </span>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="col-2 col-md-3"></div>
            </div>
        </div>
    `,
})
class CoachingComponentStripComponent {
    @Input() coachingComponents: Observable<CoachingInsightComponent[]>;
    @Input() hasPendingData: boolean;
    @Input() hasPendingPeople: boolean;
    @Output() toggledComponent: EventEmitter<CoachingInsightComponent> =
        new EventEmitter<CoachingInsightComponent>();

    activeTabView: Observable<ACTIVE_TAB_VIEW>;
    i18n = TranslationKeyMap;

    activeComponent: CoachingInsightComponent;

    selectedUser: any;

    hover: boolean = false;

    constructor(
        private readonly _teamOaService: TeamOAService,
        private readonly cd: ChangeDetectorRef,
    ) {}

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    activateComponent(comp?: CoachingInsightComponent) {
        if (comp) {
            this.activeComponent = comp;
        }

        // eslint-disable-next-line @typescript-eslint/dot-notation
        if (!this.cd['destroyed']) {
            this.cd.detectChanges();
        }
    }

    getIconStyle(): Object {
        return {
            color:
                this.getIconClass() || this.hover === true
                    ? 'rgb(120, 167, 70)'
                    : 'rgb(206, 210, 213)',
        };
    }

    getIconClass(): string {
        return this.activeComponent.iconstate === true || this.hover === true
            ? 'green'
            : 'gray';
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnInit() {
        this.activeTabView = this._teamOaService.activeView;

        const onetimecompsub = this.coachingComponents.subscribe((c) => {
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            if (c && c.length) {
                this.activeComponent = c.find((g) => g.iconstate === true);

                onetimecompsub.unsubscribe();

                // eslint-disable-next-line @typescript-eslint/dot-notation
                if (!this.cd['destroyed']) {
                    this.cd.detectChanges();
                }
            }
        });

        // eslint-disable-next-line @typescript-eslint/dot-notation
        if (!this.cd['destroyed']) {
            this.cd.detectChanges();
        }
    }
}

// !!!!!!!!!!!!!!!!!!USE THIS FOR RADIALS IN OA!!!!!!!!!!!!!!!!!!!!!!!
// <div class="coaching-component"
//     (mouseover)="hovered = true; hover.emit(hovered);"
//     (mouseleave)="hovered = false; hover.emit(hovered);">
//     <span class="description">{{component.componentShortName}}</span>
//     <div class="component-value">
//         <div class="component-value-sec">
//             <div class="insight-chart"
//                 role="button"
//                 data-chart
//                 (click)="toggleComponent();"
//                 #k="ngbTooltip"
//                 tooltipClass="oa-widget-tooltip"
//                 [ngbTooltip]="attributeTooltip"
//                 placement="top"
//                 container="body">

//                 <ng-chart-arc [options]="opts"
//                     [data]="data"
//                     *ngIf="data && component.componentTypeId != null">
//                 </ng-chart-arc>

//                 <span class="icon" *ngIf="component.componentTypeId != null">
//                     <span class="cmps-circle-plus" [ngClass]="{ 'cmps-circle-cross': component.iconstate === true }" [ngStyle]="getIconStyle()"></span>
//                 </span>

//                 <ng-template #blankOA>
//                     <span class="integer" *ngIf="component.componentTypeId != null">
//                         -
//                     </span>
//                 </ng-template>

//             </div>
//         </div>
//     </div>
// </div>

// the actual CoachingComponent numbers
@Component({
    selector: 'cmps-coaching-component',
    template: `
        <div
            class="coaching-component"
            (mouseover)="hovered = true; hover.emit(hovered)"
            (mouseleave)="hovered = false; hover.emit(hovered)"
        >
            <span class="description">{{ component.componentShortName }}</span>
            <div class="component-value">
                <div
                    [style.color]="component.thresholdColour"
                    (click)="toggleComponent()"
                >
                    <span
                        class="icon"
                        *ngIf="
                            component.componentTypeId != null &&
                            hasPendingPeople === false
                        "
                    >
                        <cmps-icon
                            [ngStyle]="getIconStyle()"
                            [svgIcon]="
                                component.iconstate === true
                                    ? 'close-circle-outline'
                                    : 'plus-circle-outline'
                            "
                        ></cmps-icon>
                    </span>
                    <ng-container
                        *ngIf="
                            activeComponentId === component.componentTypeId ||
                                activeTabView == null ||
                                (activeTabView == ACTIVE_TAB_VIEW.TEAM &&
                                    component.displayValue != null);
                            else blankOA
                        "
                    >
                        <span
                            class="integer"
                            #k="ngbTooltip"
                            tooltipClass="oa-widget-tooltip"
                            [ngbTooltip]="attributeTooltip"
                            placement="top"
                            container="body"
                        >
                            <ng-container
                                *ngIf="
                                    component.componentTypeId !== null;
                                    else loadingComp
                                "
                            >
                                <ng-container
                                    *ngIf="
                                        hasPendingPeople === false;
                                        else loadingPeople
                                    "
                                >
                                    {{
                                        component.displayValue != null &&
                                        (activeTabView ===
                                            ACTIVE_TAB_VIEW.TEAM ||
                                            activeTabView === null)
                                            ? (component.displayValue
                                              | cmpsNumberWithSuffix: '1.0-0')
                                            : '-'
                                    }}
                                </ng-container>
                            </ng-container>
                            <ng-template #loadingComp>
                                <span class="integer"> - </span>
                            </ng-template>
                        </span>
                        <span
                            class="percentage"
                            *ngIf="isPercent() && hasPendingPeople === false"
                            >%</span
                        >
                    </ng-container>
                    <ng-template #blankOA>
                        <ng-container
                            *ngIf="
                                hasPendingPeople === false;
                                else loadingPeople
                            "
                        >
                            <span
                                class="integer"
                                *ngIf="component.componentTypeId != null"
                            >
                                -
                            </span>
                        </ng-container>
                    </ng-template>

                    <ng-template #loadingPeople>
                        <cmps-wait-status class="p-2"></cmps-wait-status>
                    </ng-template>
                </div>
            </div>
        </div>

        <ng-template #attributeTooltip>
            <div
                *ngIf="
                    component.componentAttributes &&
                    component.componentTypeId == CoachingComponentType.OA
                "
                class="custom-tooltip oatooltip"
            >
                <div class="component-mini-view">
                    <table>
                        <tr class="component-view-divider">
                            <th>
                                {{ i18n._7372_TOTAL_OPPORTUNITIES | translate }}
                            </th>
                            <td>
                                {{
                                    component.componentAttributes
                                        .totalOpportunities | number: '1.0-0'
                                }}
                            </td>
                        </tr>
                        <tr class="component-view-divider">
                            <th>
                                {{
                                    i18n._7427_EXPECTED_OPPORTUNITIES
                                        | translate
                                }}
                            </th>
                            <td>
                                {{
                                    component.componentAttributes
                                        .expectedOpportunities | number: '1.0-0'
                                }}
                            </td>
                        </tr>
                        <tr class="component-view-divider">
                            <th>
                                {{
                                    i18n._7371_COACHED_OPPORTUNITIES | translate
                                }}
                            </th>
                            <td>
                                {{
                                    component.componentAttributes
                                        .coachedOpportunities | number: '1.0-0'
                                }}
                            </td>
                        </tr>
                        <tr class="component-view-divider">
                            <th>{{ i18n._7313_LAST_UPDATE | translate }}</th>
                            <td>
                                {{
                                    component.componentAttributes.lastUpdated
                                        | cmpsDate: 'MMM d, y, h:mm a'
                                }}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div
                *ngIf="
                    component.componentAttributes &&
                    component.componentTypeId == CoachingComponentType.FLOA
                "
                class="custom-tooltip oatooltip"
            >
                <div class="component-mini-view">
                    <table>
                        <tr class="component-view-divider">
                            <th>
                                {{ i18n._7372_TOTAL_OPPORTUNITIES | translate }}
                            </th>
                            <td>
                                {{
                                    component.componentAttributes
                                        .totalOpportunities | number: '1.0-0'
                                }}
                            </td>
                        </tr>
                        <tr class="component-view-divider">
                            <th>
                                {{
                                    i18n._7427_EXPECTED_OPPORTUNITIES
                                        | translate
                                }}
                            </th>
                            <td>
                                {{
                                    component.componentAttributes
                                        .expectedOpportunities | number: '1.0-0'
                                }}
                            </td>
                        </tr>
                        <tr class="component-view-divider">
                            <th>
                                {{
                                    i18n._7481_FUNDED_COACHED_OPPORTUNITIES
                                        | translate
                                }}
                            </th>
                            <td>
                                {{
                                    component.componentAttributes
                                        .fundedCoachedOpps | number: '1.0-0'
                                }}
                            </td>
                        </tr>
                        <tr class="component-view-divider">
                            <th>{{ i18n._7493_TOTAL_AGENTS | translate }}</th>
                            <td>
                                {{
                                    component.componentAttributes.totalAgents
                                        | number: '1.0-0'
                                }}
                            </td>
                        </tr>
                        <tr class="component-view-divider">
                            <th>
                                {{
                                    i18n._7494___OF_AGENTS_WITH_OPPORTUNITIES
                                        | translate
                                }}
                            </th>
                            <td>
                                {{
                                    component.componentAttributes
                                        .pctAgentsWithOpps | percent
                                }}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </ng-template>
    `,
})
class CoachingComponent implements OnChanges {
    @Input() component: CoachingInsightComponent;
    @Input() activeTabView: ACTIVE_TAB_VIEW;
    @Input() hasPendingData: boolean;
    @Input() hasPendingPeople: boolean;
    @Input() activeComponentId: number;
    @Output() toggledComponent: EventEmitter<CoachingInsightComponent> =
        new EventEmitter<CoachingInsightComponent>();

    @Output() hover: EventEmitter<boolean> = new EventEmitter<boolean>();

    i18n = TranslationKeyMap;

    hovered = false;

    @ViewChild('attributeTooltip', { static: true })
    attributeTooltip: TemplateRef<any>;

    ACTIVE_TAB_VIEW = ACTIVE_TAB_VIEW;

    CoachingComponentType = CoachingComponentType;

    opts: any;
    data: any;

    constructor(
        private readonly _coachingInsightService: CoachingInsightWidgetService,
        private readonly _suffixPipe: CmpsDecimalWithSuffixPipe,
        private readonly cd: ChangeDetectorRef,
    ) {}

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnInit() {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (this.component && this.component.componentTypeId !== null) {
            this.opts = {
                rect: { width: '100%', height: 120, top: 5, bottom: 5 },
                label: {
                    formatter: () =>
                        this.component.displayValue != null
                            ? `${this._suffixPipe.transform(
                                  this.component.displayValue,
                                  '1.0-0',
                              )}%`
                            : '-',
                    maxFontSize: 23,
                },
                innerRadius: 0.8,
            };
            this.data = [
                {
                    x: '',
                    y: this.component.displayValue,
                    color: this.component.thresholdColour || 'black',
                },
                {
                    x: 'gap',
                    y: 100 - this.component.displayValue,
                    color: 'grey',
                },
            ];
        }
    }

    // modify to use displayFormat
    isPercent(): boolean {
        return this.component.displayValue != null;
    }

    getIconStyle(): Object {
        return {
            color:
                this.getIconClass() || this.hovered === true
                    ? 'rgb(120, 167, 70)'
                    : 'rgb(206, 210, 213)',
        };
    }

    getIconClass(): string {
        return this.component.iconstate === true || this.hovered === true
            ? 'green'
            : 'gray';
    }

    toggleComponent(): void {
        if (!this.hasPendingData && !this.hasPendingPeople) {
            this._coachingInsightService.toggleComponent(this.component);
            this.toggledComponent.emit(this.component);
        }

        // eslint-disable-next-line @typescript-eslint/dot-notation
        if (!this.cd['destroyed']) {
            this.cd.detectChanges();
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnChanges(args: SimpleChanges) {
        // eslint-disable-next-line no-prototype-builtins
        if (args.hasOwnProperty('component')) {
            this.toggledComponent.emit(this.component);
        }
    }
}

// sub menu for each CoachingComponent number
@Component({
    selector: 'cmps-coaching-submenu',
    template: `
        <button
            class="component-value-items component-value-item-1"
            (click)="toggleSubmenu(sub.subComponentTypeId)"
        >
            <span class="icon component-value-icon-small">
                <cmps-icon
                    [ngStyle]="subStyle"
                    [svgIcon]="
                        sub.active === true
                            ? 'close-circle-outline'
                            : 'plus-circle-outline'
                    "
                ></cmps-icon>
            </span>
            <span
                class="component-value-items-sub-sec"
                [ngStyle]="{ opacity: sub.active == false ? 0.5 : 1 }"
            >
                <span class="component-value-name">{{
                    sub.subComponentName
                }}</span>
                <ng-container
                    *ngIf="
                        activeTabView == ACTIVE_TAB_VIEW.TEAM;
                        else noSubComponentValue
                    "
                >
                    <span
                        class="integer-small"
                        [style.color]="sub.thresholdColour"
                        >{{ sub.displayValue }}</span
                    >
                </ng-container>
                <ng-template #noSubComponentValue>
                    <span
                        class="integer-small"
                        [style.color]="sub.thresholdColour"
                    ></span>
                </ng-template>
            </span>
        </button>
    `,
})
class CoachingComponentSubmenu {
    @Input() sub: CoachingInsightSubComponent;
    @Input() subStyle: Object;
    @Input() activeTabView: ACTIVE_TAB_VIEW;

    ACTIVE_TAB_VIEW = ACTIVE_TAB_VIEW;

    hover = false;

    constructor(
        private readonly _coachingInsightService: CoachingInsightWidgetService,
        private readonly _teamOAService: TeamOAService,
        private readonly cd: ChangeDetectorRef,
    ) {}

    toggleSubmenu(subComponentTypeId: any): void {
        this._coachingInsightService.toggleSubmenu(
            this.sub,
            subComponentTypeId,
        );
        this._teamOAService.toggleColumn(subComponentTypeId);

        // eslint-disable-next-line @typescript-eslint/dot-notation
        if (!this.cd['destroyed']) {
            this.cd.detectChanges();
        }
    }
}
